<style>
    .camera-btn {
        margin: 10px 0 10px 10px;
    }
</style>

<template>
    <div>
        <qrcode-stream  :camera="camera" :torch="flashActive" @decode="onDecode" @init="onInit">
            <v-btn class="camera-btn ml-4 mb-4" color="primary" @click="flashActive = !flashActive" v-if="hasFlash">
                <v-icon>mdi-flash</v-icon>
            </v-btn>
            <v-btn class="camera-btn ml-4 mb-4" color="primary" @click="switchCamera" v-if="noCameras > 1">
                <v-icon>mdi-camera-retake-outline</v-icon>
            </v-btn>
            <v-container v-if="loading" class="text-center" style="top: 50%;">
                <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
            </v-container>
        </qrcode-stream>
    </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'

export default {
    name: 'zoezi-qr-scanner',

    zoezi: {
        title: 'QR scanner',
        icon: 'mdi-qrcode-scan'
    },

    components: { QrcodeStream },

    data: () => ({
        camera: 'auto',
        noCameras: 0,
        flashActive: false,
        hasFlash: null,
        loading: false
    }),

    methods: {
        onDecode(result) {
            this.code = result;
            this.$emit('scan', result);
        },
        async onInit (promise) {
            this.loading = true;
            try {
                const { capabilities } = await promise;
                this.hasFlash = !!capabilities.torch;

                const device = (await navigator.mediaDevices.enumerateDevices())
                    .filter(({ kind }) => kind === "videoinput")
                    .filter(({ label }) => !["OBS Virtual Camera", "OBS-Camera"].includes(label))
                    .filter(({ label }) => !label.includes("infrared"));

                this.noCameras = device.length ?? 0;
            } catch (e) {
                console.error(e);
            } finally {
                this.loading = false;
            }
        },
        switchCamera() {
            switch (this.camera) {
                case 'front':
                    this.camera = 'rear';
                    break;
                case 'rear':
                    this.camera = 'front';
                    break;
            }
        }
    }
}
</script>
